/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { css, jsx } from '@emotion/react'

import { EuiHorizontalRule, EuiIcon, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { ProfileState } from '@modules/ui-types'

import type { FunctionComponent } from 'react'

type Props = {
  profile: NonNullable<ProfileState>
}

const trialWelcomeStyles = css`
  flex-direction: column;
`

const trialWelcomeLogoStyles = css`
  margin-right: 0.75rem;
`

const trialDescriptionStyles = css`
  width: 80%;
`

const TrialWelcome: FunctionComponent<Props> = ({ profile }) => {
  const { trial_length } = profile

  return (
    <div>
      <div css={trialWelcomeStyles}>
        <EuiTitle size='l'>
          <h2>
            <EuiIcon type='logoElastic' size='xl' css={trialWelcomeLogoStyles} />
            <FormattedMessage
              id='deployments-index.in-trial'
              defaultMessage='Welcome to your {days}-day trial!'
              values={{
                days: trial_length,
              }}
            />
          </h2>
        </EuiTitle>
        <EuiSpacer size='s' />

        <div css={trialDescriptionStyles}>
          <EuiText>
            <p>
              <FormattedMessage
                id='deployments-index.trial-description-1'
                defaultMessage='Enjoy your free deployment with the latest Elasticsearch and Kibana versions, security features, machine learning, and much more. It’s all on us. If you enjoy the Elasticsearch Service, add a credit card and only pay for what you use.'
              />
            </p>
          </EuiText>
        </div>

        <EuiSpacer size='s' />
      </div>

      <EuiHorizontalRule />
    </div>
  )
}

export default TrialWelcome
